import {
  B2bSavingPlanDeductibilityValues,
  ONLY_DEDUCTIBLE_B2B_CATEGORIES,
  ONLY_NON_DEDUCTIBLE_B2B_CATEGORIES,
} from '@Common/types/b2b/plans';

import type { B2bSavingPlanDeductibility, B2bSavingPlanType } from '@Common/types/b2b/plans';

export function getAllowedDeductibilityForPlanType(
  planType: B2bSavingPlanType,
): B2bSavingPlanDeductibility[] {
  return B2bSavingPlanDeductibilityValues.filter((deductibility) => {
    if (
      deductibility !== 'non_deductible' &&
      ONLY_NON_DEDUCTIBLE_B2B_CATEGORIES.some((category) => planType.includes(category))
    ) {
      return false;
    }
    if (
      deductibility !== 'deductible' &&
      ONLY_DEDUCTIBLE_B2B_CATEGORIES.some((category) => planType.includes(category))
    ) {
      return false;
    }
    return true;
  });
}
